import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { BRAND } from "@/lib/brand";

export default function AdminLoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(form.email, form.password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Benvingut.");
      navigate("/admin");
    } else {
      toast.error(res.error || "Error");
    }
  };

  return (
    <div className="min-h-screen flex bg-[#fdfcf9]" data-testid="admin-login-page">
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <img
          src={BRAND.photos.interior}
          alt="Aura"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#2e5949]/65" />
        <div className="relative z-10 p-16 flex flex-col justify-between text-[#fdfcf9]">
          <Link to="/">
            <img src={BRAND.logoUrl} alt="Aura" className="h-10 brightness-0 invert" />
          </Link>
          <div>
            <p className="uppercase tracking-[0.28em] text-xs text-[#E2C9A0] mb-4">Panel administratiu</p>
            <h2 className="font-display text-5xl tracking-tight max-w-md leading-tight">
              Gestiona el calendari que il·luminarà les pròximes nits.
            </h2>
          </div>
          <p className="text-[#fdfcf9]/60 text-sm tracking-[0.22em] uppercase">© Aura Events</p>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.form
          onSubmit={onSubmit}
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-md"
          data-testid="admin-login-form"
        >
          <Link to="/" className="lg:hidden mb-6 block">
            <img src={BRAND.logoUrl} alt="Aura" className="h-10" />
          </Link>
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-3">Accés restringit</p>
          <h1 className="font-display text-4xl tracking-tight mb-2">Iniciar sessió</h1>
          <p className="text-[#5C544F] mb-8">Només administradors d'Aura.</p>

          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-[0.18em] text-[#5C544F]">Email</Label>
              <Input id="email" type="email" data-testid="admin-login-email"
                value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-1 bg-white border-[#eae0df]" required />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-[0.18em] text-[#5C544F]">Contrasenya</Label>
              <Input id="password" type="password" data-testid="admin-login-password"
                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1 bg-white border-[#eae0df]" required />
            </div>
            <Button type="submit" disabled={submitting} data-testid="admin-login-submit"
              className="w-full rounded-full bg-[#3e664c] hover:bg-[#2e5949] text-[#fdfcf9] py-6 text-sm uppercase tracking-[0.18em]">
              {submitting ? "Entrant…" : "Entrar"}
            </Button>
          </div>
          <Link to="/" className="block text-center mt-8 text-xs uppercase tracking-[0.2em] text-[#5C544F] hover:text-[#3e664c]">
            ← Tornar al lloc
          </Link>
        </motion.form>
      </div>
    </div>
  );
}
